import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { Event } from './Event';
var VideoEvent = /** @class */ (function (_super) {
    __extends(VideoEvent, _super);
    function VideoEvent(type, bubbles, cancelable, status) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (status === void 0) { status = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.status = axCoerceString(status);
        return _this;
    }
    VideoEvent.classInitializer = null;
    VideoEvent.classSymbols = null;
    VideoEvent.instanceSymbols = null;
    // JS -> AS Bindings
    VideoEvent.RENDER_STATE = 'renderState';
    VideoEvent.RENDER_STATUS_UNAVAILABLE = 'unavailable';
    VideoEvent.RENDER_STATUS_SOFTWARE = 'software';
    VideoEvent.RENDER_STATUS_ACCELERATED = 'accelerated';
    return VideoEvent;
}(Event));
export { VideoEvent };
